
export default {
  name: 'v-style',
  functional: true,
  render: function (createElement, context) {
    return createElement('style', context.slots().default);
  },
};
